import React, { useState, useContext } from "react";
import {
  PlaylistAddCheckRounded,
  CloseRounded,
  MenuRounded,
  AssignmentRounded,
  WorkOutlineRounded,
  VerifiedUserOutlined,
  FeedbackRounded,
} from "@material-ui/icons";
import { Link, useLocation } from "react-router-dom";
import styles from "./SideNavigation.module.scss";
import { OverridableComponent } from "@material-ui/core/OverridableComponent";
import { SvgIconTypeMap, Collapse, Divider } from "@material-ui/core";

import cn from "classnames";
import { Paths } from "shared/types/navigation";
import Logo from "shared/icons/Logo/Logo";
import UserDropdown from "../UserDropdown/UserDropdown";
import AppContext from "context/AppContext";

import startsWith from "lodash/startsWith";

interface INavigationItem {
  value: string;
  MaterialIcon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  label: string;
  path?: Paths;
  to?: string;
  subNavigationItems?: INavigationItem[];
  isNew?: boolean;
}

const SideNavigation: React.FunctionComponent<{
  notification?: React.ReactNode;
  themeSwitcher?: React.ReactNode;
}> = ({ notification, themeSwitcher }) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const { state } = useContext(AppContext);

  const navigationItems: INavigationItem[] = [
    // {
    //   value: "challenges",
    //   MaterialIcon: FormatListBulletedRounded,
    //   label: "Challenges",
    //   path: Paths.challenges,
    // },

    {
      value: "paths",
      MaterialIcon: WorkOutlineRounded,
      label: "Paths",
      path: Paths.paths,
    },

    {
      value: "solutions",
      MaterialIcon: PlaylistAddCheckRounded,
      label: "Solutions",
      path: Paths.solutions,

      subNavigationItems: [
        {
          value: "feekbacks",
          MaterialIcon: FeedbackRounded,
          label: "Feedback",
          path: Paths.feekbacks,
        },
      ],
    },

    {
      value: "badges",
      MaterialIcon: VerifiedUserOutlined,
      label: "Badges",
      path: Paths.badges,
    },

    // {
    //   value: "top-users",
    //   MaterialIcon: GroupOutlined,
    //   label: "Top Users",
    //   path: Paths.topUsers,

    //   subNavigationItems: [
    //     {
    //       value: "badges",
    //       MaterialIcon: VerifiedUserOutlined,
    //       label: "Badges",
    //       path: Paths.badges,
    //     },
    //   ],
    // },

    // {
    //   value: "blogs",
    //   MaterialIcon: RateReviewOutlined,
    //   label: "Blogs",
    //   to: `${Paths.blogs}?theme=${state.theme}`,
    //   isNew: false,
    // },

    // {
    //   value: "resources",
    //   MaterialIcon: HelpOutlineRounded,
    //   label: "Helps",
    //   path: Paths.resources,
    // },
  ];

  return (
    <>
      <div className={styles.sideNavigation_mobileNavigation}>
        <button
          aria-label="menu"
          onClick={() => setOpen(true)}
          className={styles.sideNavigation_mobileNavigation_menuButton}
        >
          <MenuRounded />
        </button>

        <div style={{ flexGrow: 1 }} />

        {themeSwitcher}

        {notification}

        <UserDropdown />
      </div>

      <nav
        className={cn([
          styles.sideNavigation,
          { [styles.sideNavigation__closed]: !open },
        ])}
      >
        <div className={styles.sideNavigation_wrapper}>
          <button
            aria-label="close"
            className={styles.sideNavigation_closeButton}
            onClick={() => setOpen(false)}
          >
            <CloseRounded />
          </button>
          <div className={styles.sideNavigation_content}>
            <div className={styles.sideNavigation_logo}>
              <div style={{ marginTop: "var(--space-xs)", display: "block" }}>
                <Logo />
              </div>
            </div>

            <ul className={styles.sideNavigation_list}>
              {navigationItems.map(
                ({
                  MaterialIcon,
                  label,
                  value,
                  path,
                  subNavigationItems,
                  to,
                  isNew,
                }) => (
                    <li key={value}>
                      {path && (
                        <Link
                          onClick={() => setOpen(false)}
                          to={path}
                          className={cn([
                            styles.sideNavigation_list_item,
                            {
                              [styles.sideNavigation_list_item__active]:
                                pathname === path,
                            },
                          ])}
                        >
                          <MaterialIcon fontSize="small" />

                          <span className={styles.sideNavigation_list_item_label}>
                            {label}
                          </span>
                        </Link>
                      )}

                      {to && (
                        <a
                          onClick={() => setOpen(false)}
                          href={to}
                          className={cn([styles.sideNavigation_list_item])}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <MaterialIcon fontSize="small" />

                          <span className={styles.sideNavigation_list_item_label}>
                            {label}
                          </span>
                          {isNew && (
                            <span
                              className={styles.sideNavigation_list_item_newTag}
                            >
                              New
                            </span>
                          )}
                        </a>
                      )}

                      {subNavigationItems && (
                        <Collapse in={startsWith(pathname, path)}>
                          <ul
                            className={styles.sideNavigation_list}
                            style={{ marginTop: "var(--space-2xs)" }}
                          >
                            {subNavigationItems.map(
                              ({
                                MaterialIcon,
                                label,
                                value,
                                to,
                                path: subPath,
                              }) => (
                                  <li key={value}>
                                    {subPath && (
                                      <Link
                                        onClick={() => setOpen(false)}
                                        to={subPath}
                                        className={cn([
                                          styles.sideNavigation_list_item,
                                          styles.sideNavigation_list_item_sub,
                                          {
                                            [styles.sideNavigation_list_item__active]:
                                              pathname === subPath,
                                          },
                                        ])}
                                      >
                                        <MaterialIcon fontSize="small" />

                                        <span
                                          className={
                                            styles.sideNavigation_list_item_label
                                          }
                                        >
                                          {label}
                                        </span>
                                      </Link>
                                    )}

                                    {to && (
                                      <a
                                        onClick={() => setOpen(false)}
                                        href={to}
                                        className={cn([
                                          styles.sideNavigation_list_item,
                                          styles.sideNavigation_list_item_sub,
                                        ])}
                                      >
                                        <MaterialIcon fontSize="small" />

                                        <span
                                          className={
                                            styles.sideNavigation_list_item_label
                                          }
                                        >
                                          {label}
                                        </span>
                                      </a>
                                    )}
                                  </li>
                                )
                            )}
                          </ul>
                        </Collapse>
                      )}
                    </li>
                  )
              )}

              <div style={{ margin: "var(--space-sm) 0" }}>
                <Divider />
              </div>

              <li>
                <a
                  href="https://learn.devchallenges.io/"
                  className={cn([
                    styles.sideNavigation_list_item,
                    styles.sideNavigation_list_item_default,
                  ])}
                >
                  <svg width="22" viewBox="0 0 100 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M11.79 43.2313L32.7059 55.3071C36.7786 57.6585 41.9862 56.2631 44.3376 52.1904C46.6889 48.1178 45.2935 42.9101 41.2209 40.5588L27.6957 32.75L15.4513 41.3244C14.2916 42.1365 13.0603 42.7703 11.79 43.2313Z" fill="var(--blue-dark)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.63141 21.078L31.5308 1.54086C35.3829 -1.15666 40.6924 -0.220687 43.3899 3.63141C44.0643 4.59444 44.5116 5.64855 44.743 6.73017C45.1271 8.52582 44.9163 10.3973 44.1617 12.0536C43.5528 13.3903 42.5896 14.5869 41.2994 15.4904L13.4 35.0276C9.54788 37.7251 4.23837 36.7891 1.54086 32.937C0.499002 31.4493 -0.000839703 29.7441 1.05885e-06 28.0559C0.00136623 25.3733 1.26712 22.7336 3.63141 21.078Z" fill="var(--blue-dark)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M87.3994 13.2179L66.4835 1.14208C62.4109 -1.20927 57.2032 0.186125 54.8519 4.25877C52.5005 8.33142 53.8959 13.5391 57.9686 15.8904L71.4938 23.6992L83.7382 15.1248C84.8979 14.3127 86.1292 13.679 87.3994 13.2179Z" fill="var(--blue-dark)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M95.558 35.3712L67.6587 54.9084C63.8066 57.6059 58.4971 56.6699 55.7995 52.8178C55.1252 51.8548 54.6779 50.8007 54.4465 49.719C54.0623 47.9234 54.2732 46.0519 55.0277 44.3956C55.6367 43.0589 56.5998 41.8623 57.8901 40.9588L85.7895 21.4216C89.6416 18.7241 94.9511 19.6601 97.6486 23.5122C98.6905 25 99.1903 26.7052 99.1895 28.3933C99.1881 31.076 97.9223 33.7156 95.558 35.3712Z" fill="var(--blue-dark)" />
                  </svg>

                  <span className={styles.sideNavigation_list_item_label}>
                    Learn
                  </span>
                </a>

                <a
                  href="https://blogs.devchallenges.io/"
                  className={cn([
                    styles.sideNavigation_list_item,
                    styles.sideNavigation_list_item_default,
                  ])}
                >
                  <svg width="22" viewBox="0 0 100 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M11.79 43.2313L32.7059 55.3071C36.7786 57.6585 41.9862 56.2631 44.3376 52.1904C46.6889 48.1178 45.2935 42.9101 41.2209 40.5588L27.6957 32.75L15.4513 41.3244C14.2916 42.1365 13.0603 42.7703 11.79 43.2313Z" fill="var(--purple-dark)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.63141 21.078L31.5308 1.54086C35.3829 -1.15666 40.6924 -0.220687 43.3899 3.63141C44.0643 4.59444 44.5116 5.64855 44.743 6.73017C45.1271 8.52582 44.9163 10.3973 44.1617 12.0536C43.5528 13.3903 42.5896 14.5869 41.2994 15.4904L13.4 35.0276C9.54788 37.7251 4.23837 36.7891 1.54086 32.937C0.499002 31.4493 -0.000839703 29.7441 1.05885e-06 28.0559C0.00136623 25.3733 1.26712 22.7336 3.63141 21.078Z" fill="var(--purple-dark)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M87.3994 13.2179L66.4835 1.14208C62.4109 -1.20927 57.2032 0.186125 54.8519 4.25877C52.5005 8.33142 53.8959 13.5391 57.9686 15.8904L71.4938 23.6992L83.7382 15.1248C84.8979 14.3127 86.1292 13.679 87.3994 13.2179Z" fill="var(--purple-dark)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M95.558 35.3712L67.6587 54.9084C63.8066 57.6059 58.4971 56.6699 55.7995 52.8178C55.1252 51.8548 54.6779 50.8007 54.4465 49.719C54.0623 47.9234 54.2732 46.0519 55.0277 44.3956C55.6367 43.0589 56.5998 41.8623 57.8901 40.9588L85.7895 21.4216C89.6416 18.7241 94.9511 19.6601 97.6486 23.5122C98.6905 25 99.1903 26.7052 99.1895 28.3933C99.1881 31.076 97.9223 33.7156 95.558 35.3712Z" fill="var(--purple-dark)" />
                  </svg>

                  <span className={styles.sideNavigation_list_item_label}>
                    Blogs
                  </span>
                </a>
              </li>

              <div style={{ margin: "var(--space-sm) 0" }}>
                <Divider />
              </div>

              {state.user && (
                <>
                  <li>
                    <Link
                      onClick={() => setOpen(false)}
                      to={Paths.mySolutions}
                      className={cn([
                        styles.sideNavigation_list_item,
                        {
                          [styles.sideNavigation_list_item__active]:
                            pathname === Paths.mySolutions,
                        },
                      ])}
                    >
                      <AssignmentRounded fontSize="small" />

                      <span className={styles.sideNavigation_list_item_label}>
                        My Solutions
                      </span>
                    </Link>
                  </li>
                </>
              )}
            </ul>

            {/* {matchPath(pathname, Paths.solutionDetails) && (
              <>
                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    margin: "var(--space-xs) 0",
                    backgroundColor: "var(--grey-3)",
                  }}
                />

                <div className={styles.sideNavigation_list}>
                  <h6 className={styles.sideNavigation_list_heading}>
                    On this page:
                  </h6>
                  <ul>
                    <li>
                      <a
                        className={styles.sideNavigation_list_item}
                        href="#summary"
                        onClick={() => setOpen(false)}
                      >
                        Summary
                      </a>
                    </li>
                    <li>
                      <a
                        className={styles.sideNavigation_list_item}
                        href="#preview"
                      >
                        Preview
                      </a>
                    </li>
                    <li>
                      <a
                        className={styles.sideNavigation_list_item}
                        href="#feedbacks"
                      >
                        Feedbacks
                      </a>
                    </li>
                  </ul>
                </div>
              </>
            )} */}
          </div>
        </div>
      </nav>
    </>
  );
};

export default SideNavigation;
